import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import type { RecipientStatusFilter } from '../types';
import { StatusFilterButtons } from './StatusFilterButtons';

interface RecipientsToolbarProps {
  selectedCount: number;
  search: string;
  onSearchChange: (_value: string) => void;
  statusFilter: RecipientStatusFilter;
  onStatusFilterChange: (_value: RecipientStatusFilter) => void;
}

export const RecipientsToolbar: React.FC<RecipientsToolbarProps> = ({
  selectedCount,
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
}) => (
  <div className="flex w-full flex-col gap-6">
    <div className="flex w-full items-center justify-between gap-4">
      <p className="font-sans text-sm font-normal leading-5 tracking-normal text-[#0A0A0A]">
        <span className="font-semibold">{selectedCount}</span> destinatário
        {selectedCount === 1 ? '' : 's'} selecionado
        {selectedCount === 1 ? '' : 's'}
      </p>
    </div>

    <div className="flex w-full flex-wrap items-center gap-3">
      <div className="w-full max-w-[373px]">
        <Input
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Buscar por nome ou e-mail..."
          iconLeft={<Search className="h-4 w-4 text-[#737373]" strokeWidth={1.33} />}
          className="h-9 rounded-lg border-[#E5E5E5] bg-white px-3 py-1 shadow-none"
        />
      </div>
      <StatusFilterButtons value={statusFilter} onChange={onStatusFilterChange} />
    </div>
  </div>
);
